import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NotFound from './pages/NotFound';
import AdminDashboard from './pages/admin/AdminDashboard';
import TrainerDashboard from './pages/trainer/TrainerDashboard';
import StudentDashboard from './pages/student/StudentDashboard';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import RoleBasedRoute from './components/auth/RoleBasedRoute';
import LoadingScreen from './components/ui/LoadingScreen';
import ChangePassword from './pages/ChangePassword';

function App() {
  const { user, isLoading, userRole } = useAuth();

  useEffect(() => {
    document.title = 'FormaNote by FormaVerse';
  }, []);

  // Logging but not too verbose
  useEffect(() => {
    if (isLoading) {
      console.log('Auth state is loading...');
    } else {
      console.log('Auth state loaded:', { 
        authenticated: !!user, 
        role: userRole || 'none'
      });
    }
  }, [user, isLoading, userRole]);

  // Only show the initial loading screen if we're in the initial load
  // Don't show it for subsequent state changes
  if (isLoading && !user && !userRole) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" replace />} />
      {/* /register — inscription publique désactivée : les comptes sont créés par un admin. */}
      <Route path="/register" element={<Navigate to="/login" replace />} />
      
      <Route element={<Layout />}>
        <Route 
          path="/"
          element={<Navigate to={user ? "/dashboard" : "/login"} replace />} 
        />
        
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/change-password" element={<ChangePassword />} />
          
          <Route element={<RoleBasedRoute role="admin" />}>
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Route>
          
          <Route element={<RoleBasedRoute role="formateur" />}>
            <Route path="/trainer/*" element={<TrainerDashboard />} />
          </Route>
          
          <Route element={<RoleBasedRoute role="etudiant" />}>
            <Route path="/student/*" element={<StudentDashboard />} />
          </Route>
        </Route>
      </Route>
      
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;